import type { CommunicationInboxItem } from "@/types/communications";
import type { FirefliesTranscriptSummary } from "@/types/fireflies";

function meetingDateToIso(date?: number | null): string {
  if (date == null) return "";
  try {
    return new Date(date).toISOString();
  } catch {
    return "";
  }
}

export function firefliesToInboxItem(
  meeting: FirefliesTranscriptSummary
): CommunicationInboxItem {
  const preview =
    meeting.summary?.short_summary ||
    meeting.summary?.gist ||
    meeting.summary?.overview ||
    "";

  return {
    id: meeting.id,
    subject: meeting.title || "Untitled meeting",
    from: meeting.host_email || meeting.organizer_email || "Unknown host",
    date: meetingDateToIso(meeting.date),
    preview,
    type: "meeting",
  };
}

export function firefliesToInboxItems(
  meetings: FirefliesTranscriptSummary[]
): CommunicationInboxItem[] {
  return meetings.map(firefliesToInboxItem);
}
